import { GameName } from "./types";

export const ingameStore: Record<GameName, string | undefined> = {
  boombeach: "OpenShop",
  brawlstars: "shop",
  clashofclans: "OpenShop",
  clashroyale: "shop",
  hayday: "OpenDiamondShop",
  squadbusters: "OpenShop",
  rogue: "OpenShop",
};
